<template>
    <div class="mcompany">
        <div class="MC-intro">
            <div class="mc-bg">
                <video src="@/assets/video1.mp4" type="video/mp4" autoplay="autoplay" muted="muted" loop="loop"></video>
            </div>
            <div class="mc-bg-blur">

                <div class="mc-view-inner">
                    <div class="mc-text1">WELCOME</div>
                    <div class="mc-text2">TO</div>
                    <div class="mc-text3">WUSTONE</div>
                </div>
            </div>
            <div class="mc-text-4">Wustone은 사람을 위한<br>새로운 서비스를 만들어갑니다.</div>
        </div>
        <MCompanyPart1></MCompanyPart1>
        <MCompanyPart2></MCompanyPart2>
        <MCompanyPart3></MCompanyPart3>
       
    </div>
</template>
<script>
    import MCompanyPart1 from "./MCompanyPart1"
    import MCompanyPart2 from "./MCompanyPart2"
    import MCompanyPart3 from "./MCompanyPart3"
    export default {
        name: "MCompany",
        components: {
            MCompanyPart1,
            MCompanyPart2,
            MCompanyPart3
        },
    }
</script>
<style lang="scss" scoped>
    .mcompany {
        width: 100%;
        position: relative;

        .MC-intro {
            width: 100%;
            height: 700px;
            position: relative;

            .mc-bg {
                width: 100%;
                height: 100%;
                overflow: hidden;
                position: relative;

                video {
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }

            .mc-bg-blur {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .mc-view-inner {
                    width: 250px;
                    height: 250px;
                    padding: 10px;
                    box-sizing: border-box;
                    background-color: rgba(0, 0, 0, 0.5);
                    border: 1px solid #ffffff;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    .mc-text1 {
                        font-size: 36px;
                        font-weight: 900;
                        color: rgb(255, 255, 255);
                    }

                    .mc-text2 {
                        font-size: 36px;
                        font-weight: 900;
                        color: rgb(248, 284, 0);
                    }

                    .mc-text3 {
                        font-size: 44px;
                        font-weight: 900;
                        color: rgb(255, 255, 255);
                    }
                }
            }

            .mc-text-4 {
                width: 100%;
                position: absolute;
                left: 50%;
                bottom: 10%;
                transform: translateX(-50%);
                font-size: 20px;
                color: rgba(255, 255, 255, 0.8);
                text-align: center;
            }

        }
      

    }
</style>